import { NotificationFields } from "../../view/Modules/Notification/NotificationDataTypes";
import AxiosInstance from "../config/axiosInterceptor";
import { ContentApiRoutes } from "../../navigation/NavConstant";

export const NotificationServices = {
  createNotification: (data: NotificationFields) =>
    AxiosInstance.post(ContentApiRoutes.CREATE_NOTIFICATION, data),
  updateNotification: (id: number, data: NotificationFields) =>
    AxiosInstance.post(
      ContentApiRoutes.UPDATE_COMPANY.replace(":id", id.toString()) +
        "?_method=PUT",
      data
    ),
  recieveNotification: (notiFor?: string, rowsNeeded?: number) =>
    AxiosInstance.get(
      ContentApiRoutes.RECIEVE_NOTIFICATION +
        "?notification_for=" +
        `${notiFor ? notiFor : "user"}` +
        "&rows=" +
        `${rowsNeeded ? rowsNeeded : 5}`
    ),
  newNotificationCount: () =>
    AxiosInstance.get(ContentApiRoutes.NOTIFICATION_COUNT),
  readNotification: (idsRead: string) =>
    AxiosInstance.post(ContentApiRoutes.READ_NOTIFICATION, { ids: idsRead }),
};
